import { createQueryKeys } from "@lukemorales/query-key-factory";
import axios from "axios";
import { IdentityProvidersApi } from "mws-ts-v2-sdk";

let identityProvidersApi: IdentityProvidersApi;

const getIdentityProvidersApi = () => {
  if (!identityProvidersApi) {
    identityProvidersApi = new IdentityProvidersApi(
      undefined,
      useRuntimeConfig().public.identityServiceUrl,
      axios,
    );
  }

  return identityProvidersApi;
};

export const identityProvidersQueryKeys = createQueryKeys("identityProviders", {
  providers: () => {
    return {
      queryKey: ["identityProviders"],
      queryFn: async () => {
        const response = await getIdentityProvidersApi().v2ProvidersGet();

        return response.data;
      },
    };
  },
});
